export default __webpack_public_path__ + "04740e52740ba90e807036aee71bcc66.png";